module.exports = __webpack_public_path__ + "static/media/DSC_0186.95042e9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0186.jpg
// module id = 642
// module chunks = 0